import { Volume2 } from "lucide-react";
import { SpecimenIcon } from "../../lib/icons";
import { playVoice } from "../../lib/voice";

const pad = (n) => String(n).padStart(2, "0");

export const BenchRecent = ({ items }) => (
  <section data-testid="bench-recent" className="border border-slate-800 bg-slate-950/60 p-5">
    <p className="lab-label">Just programmed</p>
    {items.length === 0 ? (
      <p className="mt-3 font-mono text-xs text-slate-600">Nothing yet this session.</p>
    ) : (
      <ul className="mt-3 grid gap-2">
        {items.map((s) => (
          <li key={s.id} data-testid={`bench-recent-${s.slot}`} className="flex items-center gap-3 border-b border-slate-800/70 pb-2 text-sm">
            <span className="font-mono text-xs text-slate-500">#{pad(s.slot)}</span>
            <SpecimenIcon name={s.icon} size={18} className="text-emerald-300" />
            <span className="flex-1 truncate text-slate-100">{s.name}</span>
            <span className="font-mono text-xs tracking-widest text-cyan-300">{s.spore_word}</span>
            <button data-testid={`bench-recent-play-${s.slot}`} onClick={() => playVoice(s.voice, s.sound_word, s.spore_word)} className="lab-icon-btn h-7 w-7" title="Play voice">
              <Volume2 size={13} />
            </button>
          </li>
        ))}
      </ul>
    )}
  </section>
);
